import Indicator from './index.vue'
import Vue from 'vue'
import router from '../../router'
// 队列
let queue = []
let instance = null

// 预加载图片

const IndicatorController = Vue.extend(Indicator)

const indicator = opts => {
  if (Vue.prototype.$isServer) return
  if (typeof opts === 'string') {
    opts = {
      title: opts
    }
  } else {
    opts = opts || {}
  }
  const seed = queue.length
  if (!instance) {
    instance = new IndicatorController({
      propsData: opts,
      router
    })
    instance.vm = instance.$mount()
    instance.vm.seed = seed
    document.body.appendChild(instance.vm.$el)
    queue.push(instance.vm.seed)
  } else {
    Object.keys(opts).forEach(key => {
      instance[key] = opts[key]
    })
  }
  return seed
}

indicator.close = force => {
  if (force && instance) {
    queue = []
    instance.close()
    instance = null
  } else {
    queue.pop()
    if (instance && queue.length === 0) {
      instance.close()
      instance = null
    }
  }
}

export default {
  install (Vue) {
    Vue.prototype.$indicator = indicator
  }
}